/**
 * Chat data
 */
const chats = [
  {
    id: 1,
    roomId: 1,
    status: "online",
    image: "avatar0",
    name: "Amethyst Maya",
    description: "Great job on that follow-up! Remember that time kills all deals.",
    time: "05 min",
  },
  {
    id: 2,
    roomId: 2,
    status: "online",
    image: "avatar5",
    name: "Jason Ezekiel",
    description: "Hiya! How are things?",
    time: "12 min",
  },
  {
    id: 3,
    roomId: 3,
    status: "intermediate",
    image: "avatar6",
    name: "Florrie Lesly",
    description: "When do we get to meet in person??",
    time: "24 min",
  },
  {
    id: 4,
    roomId: 4,
    status: "offline",
    image: "avatar7",
    name: "Sinjin Deacon",
    description: "Let's talk.",
    time: "1 hr",
  },
]

/**
 * group list data
 */
const groups = [
  { id: 1, image: "G", name: "General" },
  { id: 2, image: "R", name: "Reporting" },
  { id: 3, image: "M", name: "Meeting" },
  { id: 4, image: "A", name: "Project A" },
  { id: 5, image: "B", name: "Project B" },
]

/**
 * contact list data
 */
const contacts = [
  {
    category: "A",
    child: [
      { id: 1, name: "Jason Ezekiel" },
      { id: 2, name: "Alfonso Fisher" },
    ],
  },
  {
    category: "B",
    child: [{ id: 1, name: "Bonnie Harney" }],
  },
  {
    category: "C",
    child: [
      { id: 1, name: "Charles Brown" },
      { id: 2, name: "Carmella Jones" },
      { id: 3, name: "Carrie Williams" },
    ],
  },
  {
    category: "D",
    child: [{ id: 4, name: "Dolores Minter" }],
  },
]

/**
 * message list data
 */
const messages = [
  {
    id: 1,
    roomId: 1,
    sender: "Amethyst Maya",
    message: "Hello!",
    createdAt: "2020-04-02T17:07:21.529Z",
  },
  {
    id: 2,
    roomId: 1,
    sender: "Jenna",
    message: "Hi Joe! Super excited to be working with you.",
    createdAt: "2020-04-02T17:07:21.529Z",
  },
  {
    id: 3,
    roomId: 1,
    sender: "Amethyst Maya",
    message: "Me too! Remember to be intentional.",
    createdAt: "2020-04-02T17:07:21.529Z",
  },
  {
    id: 4,
    roomId: 1,
    sender: "Amethyst Maya",
    message: "Great job on that follow-up! Remember that time kills all deals.",
    createdAt: "2020-04-02T17:07:21.529Z",
  },
  {
    id: 5,
    roomId: 1,
    sender: "Jenna",
    message: "Will do.",
    createdAt: "2020-04-02T17:07:21.529Z",
  },
  {
    id: 4,
    roomId: 2,
    sender: "Jason Ezekiel",
    message: "Hiya! How are things?",
    createdAt: "2020-04-02T17:07:21.529Z",
  },
  {
    id: 5,
    roomId: 3,
    sender: "Florrie Lesly",
    message: "When do we get to meet in person??",
    createdAt: "2020-04-02T17:07:21.529Z",
  },
  {
    id: 6,
    roomId: 4,
    sender: "Sinjin Deacon",
    message: "Let's talk.",
    createdAt: "2020-04-02T17:07:21.529Z",
  },
]

export { chats, messages, contacts, groups }
